import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {DateAdapter} from '@angular/material/core';

import {TranslateModule} from '@ngx-translate/core';

import {MaterialModule} from './material.module';
import {LoaderComponent} from './components/loader/loader.component';
import {CustomSnackbarComponent} from './components/loader/custom-snackbar/custom-snackbar.component';
import {BreadcrumbComponent} from './components/breadcrumb/breadcrumb.component';
import {PaginationComponent} from "./components/pagination/pagination.component";
import {CustomSpinnerComponent} from "./components/custom-spinner/custom-spinner.component";
import {CustomPopoverComponent} from "./components/custom-popover/custom-popover.component";
import {SiteUnityFiltersComponent} from "./components/site-unity-filters/site-unity-filters.component";
import {ConfirmDialogComponent} from "./components/confirm-dialog/confirm-dialog.component";
import {CdkConnectedOverlay, CdkOverlayOrigin} from "@angular/cdk/overlay";

@NgModule({
    declarations: [
        LoaderComponent,
        CustomSnackbarComponent,
        BreadcrumbComponent,
        PaginationComponent,
        CustomSpinnerComponent,
        CustomPopoverComponent,
        SiteUnityFiltersComponent,
        ConfirmDialogComponent
    ],
    providers: [],
    imports: [
        // Angular
        ReactiveFormsModule,
        CommonModule,
        FormsModule,

        // Angular Material
        MaterialModule,

        // Misc
        TranslateModule,
        CdkOverlayOrigin,
        CdkConnectedOverlay,

        // App
    ],
    exports: [
        ReactiveFormsModule,
        FormsModule,

        // Angular Material
        MaterialModule,

        TranslateModule,

        // App
        LoaderComponent,
        BreadcrumbComponent,
        PaginationComponent,
        CustomSpinnerComponent,
        CustomPopoverComponent,
        SiteUnityFiltersComponent,
        ConfirmDialogComponent
    ],
})
export class SharedModule {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    public constructor(private dateAdapter: DateAdapter<any>) {
        this.dateAdapter.setLocale('fr');
    }
}
